export default __webpack_public_path__ + "static/media/Circus_06.6ae304fd.png";